import Logo from "../../components/logo";
import Error from "../../components/error";
import CardHome from "../../components/cardHome";
import VerifyEmail from "../../components/verifyEmail";
import NavBarMain from "../../components/navBarMain";
import NavBarSearch from "../../components/navBarSearch";
import NavbarProfile from "../../components/navBarProfile";
import AddNewItemToDimension from "../../components/addNewItemToDimension";
import CardActivity from "../../components/cardActivity";
import Pagination from "../../components/pagination";
import Loader from "../../components/loader";
import ProfileShow from "../../components/profileShow";
import ProfileEdit from "../../components/profileEdit";
import VerifyEmailForchange from "../../components/verifyEmailForChange";
import ForgotPassword from "../../components/forgotPassword";
import HomeActivity from "../../components/homeActivity";
import DoneTodayTable from "../../components/homeTodayDoneTable";
//import CardGoal from "../../components/cardGoal";
import DeleteItemFromDimentions from "../../components/deleteItemFromDimention";
import ChartPieActivities from "../../components/ChartPieActivities";
import GoalChecklist from "../../components/goalChecklist";
import CardGoal from "../../components/cardGoal1";
import GoalDetails from "../../components/goalDetails";
import ActivityDetails from "../../components/activityDetails";
import SleepBoard from "../../components/sleepBoard";
import SleepSchedule from "../../components/sleepSchedule";
import DailyProgress from "../../components/dailyProgress";
import DayDetails from "../../components/dayDetails";
//////////
//import Test from "../../components/test";
import SleepVsActivity from "../../components/sleepVsActivity"
const Components = {
  Logo,
  Error,
  CardHome,
  VerifyEmail,
  NavBarMain,
  NavBarSearch,
  NavbarProfile,
  AddNewItemToDimension,
  CardActivity,
  Pagination,
  Loader,
  ProfileEdit,
  ProfileShow,
  VerifyEmailForchange,
  ForgotPassword,
  HomeActivity,
  DoneTodayTable,
  CardGoal,
  DeleteItemFromDimentions,
  ChartPieActivities,
  GoalChecklist,
  GoalDetails,
  ActivityDetails,
  SleepBoard,SleepSchedule,DailyProgress,DayDetails,SleepVsActivity
};
export default Components;
